import { extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { DO_NOT_USE_FaWrapper } from '../../../foundation/falcon/do-not-use-fa-wrapper/index.js';
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { useAccessibilityWarning } from './useAccessibilityWarning.js';
import { StyledButton } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import VisuallyHidden from '../../../../visually-hidden/VisuallyHidden.js';

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function CheckButton(props) {
  var _props$selected = props.selected,
    selected = _props$selected === void 0 ? false : _props$selected,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    label = props.label,
    restProps = __rest(props, ["selected", "size", "label"]);
  useAccessibilityWarning(props);
  return /*#__PURE__*/jsxs(StyledButton, _extends({
    $selected: selected,
    $size: size,
    "aria-pressed": selected
  }, restProps, {
    children: [/*#__PURE__*/jsx(VisuallyHidden, {
      children: label
    }), /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, {
      icon: faCheck,
      $size: 12,
      $color: "primary.0"
    })]
  }));
}

export { CheckButton };
